import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setOverlayPartnerVisible } from './actions.js';
import OverlayGeneric from '../../components/Overlay/OverlayGeneric';
import PartnerLogo from '../../components/Donation/PartnerLogo';
import PartnerDescription from '../../components/Overlay/CustomDescription';

const Overlay = props => (
    <OverlayGeneric
        isPartnerOrPublisherOverlay={true}
        logoComponent={PartnerLogo}
        aboutUsComponent={PartnerDescription}
        aboutUsContent={{
            description: props.partnerDescription,
            logoUrl: props.partnerLogoUrl
        }}
        logoIsSmall={props.logoIsSmall}
        isVisible={props.isVisible}
        isMobileResolution={props.isMobileResolution}
        setOverlayVisible={props.setOverlayPartnerVisible}
        transitionType={props.transitionType}
        title={props.partnerName}
        logo={props.logo}
        name={props.name}
        description={props.description}
    />
);

Overlay.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    transitionType: PropTypes.string.isRequired,
    isMobileResolution: PropTypes.bool.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    partnerName: PropTypes.string,
    partnerLogoUrl: PropTypes.string.isRequired,
    partnerDescription: PropTypes.string.isRequired,
    logo: PropTypes.string,
    logoIsSmall: PropTypes.bool,
    name: PropTypes.string,
    description: PropTypes.string
};

export default connect(
    state => {
        return {
            isVisible: state.widget.isOverlayPartnerVisible,
            isPartnerOverlayTransitionRegular:
                state.widget.isPartnerOverlayTransitionRegular,
            isMobileResolution: state.widget.isMobileResolution,
            partnerName:
                !!state.widget.selectedPartner
                    ? state.widget.selectedPartner.name
                    : '',
            partnerDescription:
                !!state.widget.selectedPartner
                    ? state.widget.selectedPartner.description || ''
                    : '',
            partnerLogoUrl:
                !!state.widget.selectedPartner
                    ? state.widget.selectedPartner.logoUrl || ''
                    : ''
        };
    },
    { setOverlayPartnerVisible }
)(Overlay);



// WEBPACK FOOTER //
// ./src/containers/Widget/OverlayPartner.jsx